import { HomeCampaignsController } from './home-campaigns.controller'

function homeCampaigns () {
  return {
    restrict: 'E',
    templateUrl: '/home/directives/home-campaigns/home-campaigns-directive.html?$$REVISION$$',
    controller: HomeCampaignsController
  }
}

export { homeCampaigns }
